import { useDialog } from "@/client/stores/dialog";
import { t } from "@lingui/macro";
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Form,
  FormField,
  FormItem,
  FormLabel,
  Input,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  FormControl,
  SelectValue,
  SelectTrigger,
  ScrollArea,
} from "@reactive-resume/ui";
import { useRef } from "react";
import { useForm } from "react-hook-form";
import { SelectFormField } from "@/client/pages/admin/dashboard/_components/select-form-fields";
import { useFilterPayment, useFilterTransactionForAmba } from "@/client/stores/filter";
import { FilterPaymentIntendType, FilterTransaction } from "libs/dto/src/payment";
import { Role } from "@reactive-resume/utils";
import { usefilterUser } from "@/client/services/user/filter-user";
import { useRates } from "@/client/services/rate/rates";

type StringFilterCondition = "startsWith" | "contains" | "equals" | "endsWith";
type DateFilterCondition = "gt" | "gte" | "equals" | "lt" | "lte";
type NumberFilterCondition = "gt" | "gte" | "equals" | "lt" | "lte";

type TransactionFilterFormType = {
  Amount?: {
    condition: NumberFilterCondition;
    value: string;
  };
  toAmbassador?: {
    condition: NumberFilterCondition;
    value: string;
  };
  closeDate?: {
    condition: DateFilterCondition;
    value: string;
  };
};

const ObjectConversionToFilterType = (object: TransactionFilterFormType) => {
  const filter: FilterTransaction = {};
  Object.entries(object).forEach(([key, field]) => {
    if (!field || field.value == null || Number.isNaN(field.value) || field.value === "") return;

    filter[key as keyof TransactionFilterFormType] = {
      [field.condition]: field.value,
    };
  });
  return filter;
};

export const FilterTransactionDialog = () => {
  const { isOpen, close, payload } = useDialog("filter-transaction");
  const { filter, replaceFilter } = useFilterTransactionForAmba();
  //const { filterUsers , isLoading} = usefilterUser(Role.ExtenalUser);
  const { rates } = useRates();
  const form = useForm<TransactionFilterFormType>({
    defaultValues: {
      Amount: {
        condition: "equals",
        value: "",
      },
      toAmbassador: {
        condition: "equals",
        value: "",
      },
      closeDate: {
        condition: "equals",
        value: "",
      },
    },
  });

  const onSubmit = (data: any) => {
    if (data.Amount?.value) data.Amount.value = Number(data.Amount.value);
    if (data.toAmbassador?.value) data.toAmbassador.value = Number(data.toAmbassador.value);
    const filterData = ObjectConversionToFilterType(data);
    replaceFilter({ ...filterData, ambassador: "" });
    form.reset();
    close();
  };

  return (
    <Dialog open={isOpen} onOpenChange={close}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t`Filtrer les transactions`}</DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
            <div className="flex flex-row gap-2">
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="Montant"
                  form={form}
                  condition="Number"
                  nameField="Amount.condition"
                />
                <Input {...form.register("Amount.value")} type="number" />
              </div>
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="Commission"
                  form={form}
                  condition="Number"
                  nameField="toAmbassador.condition"
                />
                <Input {...form.register("toAmbassador.value")} type="number" />
              </div>
            </div>

            <div className="flex flex-row gap-2">
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="closeDate"
                  form={form}
                  condition="Date"
                  nameField="closeDate.condition"
                />
                <Input {...form.register("closeDate.value")} type="date" />
              </div>
            </div>

            <div className="flex justify-center gap-x-3">
              <Button type="submit" className="bg-moncvpro-secondary">
                {t`Valider`}
              </Button>
              {/* <Button className="bg-moncvpro" onClick={()=> form.reset()}>
                                {t`reset`}
                            </Button> */}
            </div>
          </form>
        </Form>
      </DialogContent>
      <DialogFooter></DialogFooter>
    </Dialog>
  );
};
